import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";
import { useState } from "react";

export default function DeleteDialog({open, onClose, title, message, onConfirm, isLoading})
{
    const [removeWord,setRemoveWord] = useState('');
    const [removeWordError,setRemoveWordError] = useState(false);

    const formVerification = () => {
        let ban = 0;
        if(removeWord !== 'eliminar')
        {
            setRemoveWordError(true);
            ban = 1;
        }

        return ban;
    }

    const handleConfirm = () => {
        if(formVerification() === 0)
        {
            onConfirm();
            setRemoveWord('');
            setRemoveWordError(false);
        }
    }

    const handleOnClose = () => {
        setRemoveWord('');
        setRemoveWordError(false);
        onClose();
    }

    return(
        <Dialog
            open={open}
            onClose={onClose}
        >
            <DialogTitle>{title || 'Eliminar'}</DialogTitle>
            <DialogContent>
            <DialogContentText>
                <span style={{fontWeight:'bold'}}>{message}</span>
                <br/>Para confirmar escribe la palabra 'eliminar' y luego haz click en el botón eliminar
            </DialogContentText>
            <TextField
                autoFocus
                margin="dense"
                id="removeWord"
                placeholder="Escribe 'eliminar' "
                fullWidth
                variant="standard"
                value={removeWord}
                onChange={(e)=>setRemoveWord(e.target.value)}
                onBlur={ () => setRemoveWordError(removeWord==='') }
                error = {removeWordError}
                helperText={removeWordError && 'Debes escribir la palabra "eliminar"'}
            />
            </DialogContent>
            <DialogActions>
                <Button onClick={()=>handleOnClose()} disabled={isLoading}>Cancelar</Button>
                <Button 
                    variant="contained"
                    color="error"
                    onClick={()=>handleConfirm()} disabled={isLoading}>
                    {
                        isLoading === true
                        ?
                        <CircularProgress/>
                        :
                        'Eliminar'
                    }
                </Button>
            </DialogActions>
        </Dialog>
    )
}